var publicPath = __webpack_public_path__;
                    var symbolUrl = 'gfx/sprite.svg#icon-Hamburger_vald';
                    var viewUrl = 'gfx/sprite.svg#view-icon-Hamburger_vald';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 28 22',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };